// Rubriques de l'espace membre (/compte/:section), aussi listées dans le menu de l'avatar (header + barre mobile)
export type AccountSectionId = 'saved' | 'contributions' | 'club' | 'rewards' | 'stats' | 'badges' | 'expertise';

export interface AccountSection {
  id: AccountSectionId;
  icon: string;
  labelKey: string;
  isNew?: boolean;
}

export const ACCOUNT_SECTIONS: AccountSection[] = [
  { id: 'saved', icon: 'bookmark_border', labelKey: 'account.sections.saved' },
  { id: 'contributions', icon: 'post_add', labelKey: 'account.sections.contributions' },
  { id: 'club', icon: 'stars', labelKey: 'account.sections.club' },
  { id: 'rewards', icon: 'redeem', labelKey: 'account.sections.rewards', isNew: true },
  { id: 'stats', icon: 'bar_chart', labelKey: 'account.sections.stats' },
  { id: 'badges', icon: 'emoji_events', labelKey: 'account.sections.badges' },
  { id: 'expertise', icon: 'school', labelKey: 'account.sections.expertise', isNew: true },
];

// Catégories proposées dans le formulaire « Poster » (valeurs de categoryEnum, libellés categories.<clé>)
export const POST_CATEGORIES: { value: string; labelKey: string }[] = [
  { value: 'electro', labelKey: 'categories.electro' },
  { value: 'videoGame', labelKey: 'categories.videoGame' },
  { value: 'fashion', labelKey: 'categories.fashion' },
  { value: 'cosmetic', labelKey: 'categories.cosmetic' },
  { value: 'sport', labelKey: 'categories.sport' },
  { value: 'family', labelKey: 'categories.family' },
  { value: 'homeCategory', labelKey: 'categories.home' },
  { value: 'animal', labelKey: 'categories.animal' },
  { value: 'trip', labelKey: 'categories.trip' },
  { value: 'mechanic', labelKey: 'categories.mechanic' },
  { value: 'gardenDIY', labelKey: 'categories.gardenDIY' },
  { value: 'grocery', labelKey: 'categories.grocery' },
  { value: 'service', labelKey: 'categories.service' },
  { value: 'finance', labelKey: 'categories.finance' },
  { value: 'training', labelKey: 'categories.training' },
  { value: 'deal', labelKey: 'categories.deal' },
  { value: 'crypto', labelKey: 'categories.crypto' },
  { value: 'free', labelKey: 'categories.free' },
];

export function categoryLabelKey(value: string): string {
  return POST_CATEGORIES.find(c => c.value === value)?.labelKey || '';
}

// Date de création d'un compte déduite de son ObjectId Mongo (4 premiers octets = horodatage)
export function objectIdDate(id: string | undefined | null): Date | null {
  if (!id || id.length < 8) {
    return null;
  }
  const seconds = parseInt(id.substring(0, 8), 16);
  return isNaN(seconds) ? null : new Date(seconds * 1000);
}

export function formatDate(value: string | Date | null | undefined, language: string, withYear = true): string {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString(language, withYear ? { day: 'numeric', month: 'long', year: 'numeric' } : { day: 'numeric', month: 'long' });
}
